import React from 'react';
import Power from '@material-ui/icons/Power';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import TrendingUp from '@material-ui/icons/TrendingUp';
import Chat from '@material-ui/icons/ChatBubbleOutline';
import Receipt from '@material-ui/icons/Receipt';
import { createUrl } from '../../../../libs/createUrl';
import { roles, routesConstants, rules } from '../../../../../../../app-config';
import { t } from 'i18next';

const getLabel = (key) => t(`enoapp.${key}.title`);
const getTechnicalLabel = (key) => t(`enoapp.technical.${key}.title`);
const getFinancialLabel = (key) => t(`enoapp.financial.${key}.title`);
const getAdministrativeLabel = (key) => t(`enoapp.administrative.${key}.title`);

const itemsListConstants = () => {
    return {
        DASHBOARD: {
            key: 'dashboard',
            label: getTechnicalLabel('dashboard'),
        },
        BILLING: {
            key: 'billing/participants',
            label: getAdministrativeLabel('billing.participants'),
        },
        BILLING_SUBSCRIPTIONS: {
            key: 'billing/subscriptions',
            label: getAdministrativeLabel('billing.subscriptions'),
        },
        INVOICES: {
            key: 'billing/invoices',
            label: getAdministrativeLabel('billing.invoices'),
        },
        EDITED_INVOICES: {
            key: 'billing/invoices',
            label: getAdministrativeLabel('billing.editedInvoices'),
        },
        BILL_RUN: {
            key: 'billing/invoices-run',
            label: getAdministrativeLabel('billing.billRun'),
        },
        BILLING_CONFIG: {
            key: 'billing/configs',
            label: getAdministrativeLabel('billing.configs'),
        },
        BILLING_PLAN: {
            key: 'billing/plans',
            label: getAdministrativeLabel('billing.plans'),
        },
        PAYMENT_CONFIG: {
            key: 'payment',
            label: getAdministrativeLabel('payment'),
        },
        DOCUMENTS: {
            key: 'documents',
            label: getAdministrativeLabel('documents'),
        },
        OPERATION: {
            key: 'operation',
            label: getAdministrativeLabel('operation'),
        },
        PARTICIPANTS: {
            key: 'participants',
            label: getAdministrativeLabel('participants'),
        },
        PRODUCTION: {
            key: 'production',
            label: getTechnicalLabel('coefficients'),
        },
        DISTRIBUTION: {
            key: 'productionDistribution',
            label: getTechnicalLabel('productionDistribution'),
        },
        ALERT_MANAGEMENT: {
            key: 'alertManagement',
            label: getLabel('alertManagement'),
        },
        EXPENSE: {
            key: 'expense',
            label: getFinancialLabel('expense'),
        },
        INCOME: {
            key: 'income',
            label: getFinancialLabel('income'),
        },
        BILL_CHECK: {
            key: 'billing/check',
            label: getFinancialLabel('billCheck'),
        },
        FINMONITORING: {
            key: 'monitoring',
            label: getFinancialLabel('monitoring'),
        },
        COMMUNICATION: {
            key: 'communication',
            label: getLabel('communication'),
        },
    };
};

const toggleableDrawerList = [];

let drawerList = (selectedOperation) => {
    return [
        {
            label: t('enoapp.technical.title'),
            icon: <Power />,
            show: (selectedOperation) => true,
            list: [
                {
                    key: itemsListConstants().DASHBOARD.key,
                    label: itemsListConstants().DASHBOARD.label,
                    show: (selectedOperation) => true,
                    to: (id, role, prodId) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().DASHBOARD.key
                            }${
                                role === roles.PARTICIPANT
                                    ? `/prod/${prodId}`
                                    : ''
                            }`
                        ),
                    rbacRule: rules.DASHBOARD_VISIT,
                },
                {
                    key: itemsListConstants().PRODUCTION.key,
                    label: itemsListConstants().PRODUCTION.label,
                    show: (selectedOperation) =>
                        selectedOperation?.dso === 'ENEDIS',
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/edit/${
                                itemsListConstants().PRODUCTION.key
                            }`
                        ),
                    rbacRule: rules.PRODUCTION_VISIT,
                },
                {
                    key: itemsListConstants().DISTRIBUTION.key,
                    label: itemsListConstants().DISTRIBUTION.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/productionDistribution`
                        ),
                    rbacRule: rules.DISTRIBUTION_VISIT,
                },
            ],
            key: 'techMonCollapse',
        },
        {
            label: t('enoapp.administrative.title'),
            icon: <LibraryBooks />,
            show: (selectedOperation) => true,
            list: [
                {
                    key: itemsListConstants().BILLING_PLAN.key,
                    label: itemsListConstants().BILLING_PLAN.label,
                    show: (selectedOperation, user) =>
                        selectedOperation?.dso === 'SIBELGA' &&
                        user?.role === roles.ORGANIZER,
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILLING_PLAN.key
                            }`
                        ),
                    rbacRule: rules.BILLING_PLAN_VISIT,
                },
                {
                    key: itemsListConstants().BILLING_SUBSCRIPTIONS.key,
                    label: itemsListConstants().BILLING_SUBSCRIPTIONS.label,
                    show: (selectedOperation, user) =>
                        selectedOperation?.dso === 'SIBELGA' &&
                        user?.role === roles.ORGANIZER,
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILLING_SUBSCRIPTIONS.key
                            }`
                        ),
                    rbacRule: rules.BILLING_SUBSCRIPTION_VISIT,
                },

                {
                    key: itemsListConstants().INVOICES.key,
                    label: itemsListConstants().INVOICES.label,
                    show: (selectedOperation) =>
                        selectedOperation?.dso === 'SIBELGA',
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().INVOICES.key
                            }`
                        ),
                    rbacRule: rules.INVOICE_LIST_VISIT,
                },
                {
                    key: itemsListConstants().PAYMENT_CONFIG.key,
                    label: itemsListConstants().PAYMENT_CONFIG.label,
                    show: (selectedOperation) =>
                        selectedOperation?.dso === 'SIBELGA',
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().PAYMENT_CONFIG.key
                            }`
                        ),
                    rbacRule: rules.PAYMENT_CONFIG_VISIT,
                },
                {
                    key: itemsListConstants().PARTICIPANTS.key,
                    label: itemsListConstants().PARTICIPANTS.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/edit/${
                                itemsListConstants().PARTICIPANTS.key
                            }`
                        ),
                    rbacRule: rules.PARTICIPANTS_VISIT,
                },
                {
                    key: itemsListConstants().DOCUMENTS.key,
                    label: itemsListConstants().DOCUMENTS.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/edit/${
                                itemsListConstants().DOCUMENTS.key
                            }`
                        ),
                    rbacRule: rules.DOCUMENTS_VISIT,
                },
                {
                    key: itemsListConstants().OPERATION.key,
                    label: itemsListConstants().OPERATION.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/edit/${
                                itemsListConstants().OPERATION.key
                            }`
                        ),
                    rbacRule: rules.OPERATION_VISIT,
                },
            ],
            key: 'adminCollapse',
        },
        {
            label: t('enoapp.facturation.title'),
            icon: <Receipt />,
            show: (selectedOperation) =>
                ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                    selectedOperation?.dso
                ),
            list: [
                {
                    key: itemsListConstants().BILLING_PLAN.key,
                    label: itemsListConstants().BILLING_PLAN.label,
                    show: (selectedOperation) =>
                        ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                            selectedOperation?.dso
                        ),
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILLING_PLAN.key
                            }`
                        ),
                    rbacRule: rules.BILLING_PLAN_VISIT,
                },
                {
                    key: itemsListConstants().BILLING_SUBSCRIPTIONS.key,
                    label: itemsListConstants().BILLING_SUBSCRIPTIONS.label,
                    show: (selectedOperation) =>
                        ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                            selectedOperation?.dso
                        ),
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILLING_SUBSCRIPTIONS.key
                            }`
                        ),
                    rbacRule: rules.BILLING_SUBSCRIPTION_VISIT,
                },
                {
                    key: itemsListConstants().PAYMENT_CONFIG.key,
                    label: itemsListConstants().PAYMENT_CONFIG.label,
                    show: (selectedOperation) =>
                        ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                            selectedOperation?.dso
                        ),
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().PAYMENT_CONFIG.key
                            }`
                        ),
                    rbacRule: rules.PAYMENT_CONFIG_VISIT,
                },
                {
                    key: itemsListConstants().BILL_RUN.key,
                    label: itemsListConstants().BILL_RUN.label,
                    show: (selectedOperation) =>
                        ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                            selectedOperation?.dso
                        ),
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILL_RUN.key
                            }`
                        ),
                    rbacRule: rules.INVOICE_LIST_VISIT,
                },
                {
                    key: itemsListConstants().EDITED_INVOICES.key,
                    label: itemsListConstants().EDITED_INVOICES.label,
                    show: (selectedOperation) =>
                        selectedOperation?.dso !== 'SIBELGA',
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/billing/invoices`
                        ),
                    rbacRule: rules.INVOICE_LIST_VISIT,
                },
            ],
            key: 'facturationCollapse',
        },
        {
            label: t('enoapp.financial.title'),
            icon: <TrendingUp />,
            show: (selectedOperation) =>
                ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                    selectedOperation?.dso
                ),
            list: [
                {
                    key: itemsListConstants().EXPENSE.key,
                    label: itemsListConstants().EXPENSE.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/fin/${
                                itemsListConstants().EXPENSE.key
                            }`
                        ),
                    rbacRule: rules.EXPENSE_VISIT,
                },
                {
                    key: itemsListConstants().INCOME.key,
                    label: itemsListConstants().INCOME.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/fin/${
                                itemsListConstants().INCOME.key
                            }`
                        ),
                    rbacRule: rules.INCOME_VISIT,
                },
                {
                    key: itemsListConstants().FINMONITORING.key,
                    label: itemsListConstants().FINMONITORING.label,
                    show: (selectedOperation) => true,
                    to: (id) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/fin/${
                                itemsListConstants().FINMONITORING.key
                            }`
                        ),
                    rbacRule: rules.FINMONITORING_VISIT,
                },
                {
                    key: itemsListConstants().BILL_CHECK.key,
                    label: itemsListConstants().BILL_CHECK.label,
                    show: (selectedOperation) => true,
                    to: (id, role) =>
                        createUrl(
                            routesConstants.ENOAPP,
                            `operations/${id}/${
                                itemsListConstants().BILL_CHECK.key
                            }`
                        ),
                    rbacRule: rules.BILL_CHECK_VISIT,
                },
            ],
            key: 'finMonitoringCollapse',
        },
        {
            label: itemsListConstants().COMMUNICATION.label,
            icon: <Chat />,
            show: (selectedOperation) =>
                ['ENEDIS', 'SRD', 'SER', 'GREENALP', 'FAKE'].includes(
                    selectedOperation?.dso
                ),
            to: (id) =>
                createUrl(
                    routesConstants.ENOAPP,
                    `operations/${id}/${itemsListConstants().COMMUNICATION.key}`
                ),
            rbacRule: rules.COMMUNICATION_VISIT,
            key: 'communication',
        },
        ...(process.env.REACT_APP_FEATURE_TOGGLE === 'true'
            ? toggleableDrawerList
            : []),
    ];
};

export { drawerList, itemsListConstants };
